<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>뉴스레터 등록 기본정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">포스트 제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="10">
                            <b-form-input id="basicText" name="postsubject" type="text" v-model="queryParams.postsubject" v-validate="'required'" :class="{'is-invalid': errors.has('postsubject')}"></b-form-input>
                            <span v-show="errors.has('postsubject')" :class="{error: errors.has('postsubject')}">포스트 제목은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성 기간</label>
                    </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="2">
                            <b-form-input type="text" name="daterange" />
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" rowspan="2" style="background-color:#f1f1f1; vertical-align:middle">
                        <label class="col-form-label">이미지 업로드<br/>(1800 x 480)</label>
                      </td>
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <div :class="imgFileCheck ? 'imgfile' : 'imgfilenone'"><input type="file" class="form-control-file" id="file" ref="file" accept=".jpg, .jpeg, .png" style="padding:5px" v-on:change="handleFileUpload('MAIN_FILE')"/></div>
                            <div><b class="imgnone" style="display:inline-block; background:#ea0000; padding:7px 10px; margin:0 0 0 10px; border-radius:5px; color:#ffffff; font-size:14px; float:left">이미지는 필수로 등록해주세요.</b></div>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td class="" colspan="4">
                        <b-row class="pt-sm-12">
                          <b-col sm="12">
                            <span style="color:#ea0000; font-weight:bold; font-size:12px; display:inline-block" v-show="queryParams.listThumbnailFile.length != 0">* 이미지 확인용 입니다. 현재 업로드된 사이즈는 {{queryParams.img_width}} x {{queryParams.img_height}} 입니다.</span>
                            <div :class="imgFileCheck ? 'imgdiv' : 'imgdivnone'">
                              <div style="display: table-cell; vertical-align: middle" id="imgcreat" v-show="queryParams.listThumbnailFile.length == 0">
                                <div style="width:300px; height:25px; margin:0 auto; font-weight:bold">
                                  <i class="icon-close font-5xl" style="float:left; margin-right:10px; color:#f27474"></i>
                                  <label class="col-form-label" style="float:left; padding:0; margin:0; font-size:20px; ling-height:35px">이미지를 업로드 해주세요.</label>
                                </div>
                              </div>
                              <img :src="item.file_url" alt="img" v-for="(item, idx) in queryParams.listThumbnailFile" id="imgdata" v-show="queryParams.listThumbnailFile.length != 0">
                            </div>
                            <b-button size="sm" variant="danger" v-on:click="imgFileDelete()" id="imgdel" class="mx-1 delete_button_on" v-show="queryParams.listThumbnailFile.length != 0" style="float:right"><h5 style="margin-bottom:0px"><i class="fa fa-remove"></i> 제거</h5></b-button>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">랜딩 URL</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="10">
                            <b-form-input id="basicText" name="landingurl" type="text" v-model="queryParams.landing_url" v-validate="'required'" :class="{'is-invalid': errors.has('landingurl')}"></b-form-input>
                            <span v-show="errors.has('landingurl')" :class="{error: errors.has('landingurl')}">포스트 제목은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">활성화</label>
                      </td>
                      <td class="" style="vertical-align:middle">
                        <c-switch type="text" variant="primary" v-model="queryParams.active_yn" on="On" off="Off" :pill="true" :checked="true" style="margin:0px"/>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">슬롯번호</label>
                      </td>
                      <td class=""><!-- queryParams.rating_point_code -->
                        <multiselect v-model="mainSlotData" :options="mainSlotNumberOptions" :custom-label="mainSlotNumLabel" :disabled="true" placeholder="메인 슬롯 번호" label="num" style="width:570px" track-by="num"></multiselect>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">설명</label>
                    </td>
                    <td class="" colspan="4">
                      <textarea id="basicText" rows="10" cols="200" style="border:1px solid #c2cfd6" v-model="queryParams.explanation"></textarea>
                    </td>
                  </tr>
                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="warning" v-on:click="saveMainBanner()" v-if="formtype == 'update'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #c5940d; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-edit"></i> 수정</h5></b-button>
                  <b-button variant="success" v-on:click="saveMainBanner()" v-if="formtype == 'insert'" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/main/mainmanagement'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import datetimepicker from "daterangepicker/daterangepicker.js";
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import cSwitch from '../../components/Switch'

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    Multiselect,
    cSwitch
  },
  data() {
    return {
      bannercode: '',
      imgFileCheck: true,
      newFlag:'new',
      pageOptions: [5, 10, 30, 50, 100],
      mainSlotNumberOptions: [], // 슬롯 넘버 선택시 옵션
      mainSlotData: '',
      formtype: '',
      queryParams: {
        postsubject: '',
        banner_type: 'mainbanner',
        contents_type: 'img',
        img_url: '',
        img_width: 0,
        img_height: 0,
        landing_url: '',
        active_yn: 'Y',
        slot_number: 1,
        explanation: '',
        listThumbnailFile:[],
        start_date: moment().format('YYYY-MM-DD'),
        end_date: moment().add(3, 'months').format('YYYY-MM-DD'),
        reg_date: moment().format('YYYY-MM-DD'),
      },
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      config: {
        toolbar:[
  				{ name: 'document', items: [ 'Source' ] },
  	      { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
  	      { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
  	      '-',
  	      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
  	      { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
  	      { name: 'links', items: ['Link', 'Unlink'] },
  	      '/',
  	      { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
  	      { name: 'colors', items: ['TextColor', 'BGColor'] },
				],
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        height: 300
      },
      enabled: true,
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;
    self.bannercode = self.$session.get('bannercode');

    if(self.formtype == 'update'){
      self.getMainManagementData(self.bannercode);
    }
    self.getSlotNumberOptions();

    $(function() {
      $(".imgnone").hide();
      $('input[name="daterange"]').daterangepicker({
        opens: 'left',
        "locale": self.calendarLocale,
        "endDate": moment().add(3, 'months').format('YYYY-MM-DD'),
        "startDate": moment().format('YYYY-MM-DD')
      }, function(start, end, label) {
        self.queryParams.start_date = start.format('YYYY-MM-DD');
        self.queryParams.end_date = end.format('YYYY-MM-DD');
      });
    });
  },
  methods: {
    mainSlotNumLabel ({ name, num }) {
      return `${num} - ${name}`
    },
    // 메소드명 : drFreeReportOption()
    // ### 무료 리포트 목록을 조회한다 ###
    // 무료 리포트 목록을 조회하여 해당 유료 컨텐츠의 요약본 다운로드에 필요한 링크 저장
    //
    // 최초작성 : 2016.07.21
    // 파라미터 :
    //  - dr_deth_code(그룹코드 값)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.07.21  황경현   최초작성
    // *************************
    getSlotNumberOptions() {
      var self = this;
      // self.mainSlotNumberOptions = [
      //   {num:1, name:'종합보고서 2020 출시'},
      //   {num:2, name:'예약된 보고서 이벤트'},
      //   {num:3, name:'인터넷 보고서'},
      //   {num:4, name:'2020 인터넷 쇼핑 형태 및 구매'},
      //   {num:5, name:'2020 동영상 시청형태'},
      // ];
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.queryParams));
      var data = new FormData();
      data.append('objs', param);
      self.$http.post('/api/select/slotNumberOptions?access_token=' + token, data, null)
      .then((result) => {
        var slotNumberDatas = [];
        slotNumberDatas = result.data;
        if(self.formtype != 'update'){
          self.mainSlotNumberOptions.push(
            {code:'newbanner',name:'현재 적용중', num:1}
          );
        }

        slotNumberDatas.forEach(function (el, idx, arr){
          var setSlotNum = el.slot_number;
          if(self.formtype != 'update'){
            setSlotNum = setSlotNum + 1;
          }
          var items = {
            code: el.banner_code,
            name: el.postsubject,
            num: setSlotNum,
          };
          self.mainSlotNumberOptions.push(items);
          if(idx == 0){
            self.mainSlotData = el;
          }
          self.mainSlotNumberOptions.sort(function(a, b) { // 오름차순
            return a.num < b.num ? -1 : a.num > b.num ? 1 : 0;
          });
        });

        setTimeout(function(){
          if(self.formtype == 'update'){
            self.mainSlotNumberOptions.forEach(function (el, idx, arr){
              if(el.num == self.queryParams.slot_number){
                self.mainSlotData = el;
              }
            });
          }else{
            self.mainSlotNumberOptions.forEach(function (el, idx, arr){
              if(idx == 0){
                self.mainSlotData = el;
              }
            });
          }
        }, 100);

      })
    },
    // 메소드명 : getMainManagementData(val)
    // ### 메인배너 데이터 조회 ###
    // 메인배너 데이터 조회용
    //
    // 최초작성 : 2020.08.24
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2020.08.24  황경현   최초작성
    // *************************
    getMainManagementData(bannercode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/mainBannerData?access_token=' + token + '&bannercode=' + bannercode)
      .then((result) => {
        self.queryParams = result.data;
        self.queryParams.listThumbnailFile = [];
        var fileArr = {
          file_url: self.queryParams.img_url,
          file_width: self.queryParams.img_width,
          file_height: self.queryParams.img_height,
        };
        self.queryParams.listThumbnailFile.push(fileArr);
        console.log(self.queryParams);
      })
    },
    // 메소드명 : saveMainBanner()
    // ### 메인배너 저장 및 수정###
    // 메인배너 파라미터의 값의 따라 저장 및 수정.
    //
    // 최초작성 : 2020.08.20
    // 파라미터 : formtype => insert(저장), update(수정)
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자    수정내용
    // 2020.08.20  황경현    최초작성
    // *************************
    saveMainBanner() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(self.queryParams.listThumbnailFile.length == 0){
            $(".imgnone").show();
            self.imgFileCheck = false;
            window.scrollTo(0,0);
            return false;
          }
          self.queryParams.slotNumberDatas = self.mainSlotNumberOptions;
          self.queryParams.listThumbnailFile.forEach(function (el, idx, arr){
            self.queryParams.img_url = el.file_url;
            self.queryParams.img_width = el.file_width;
            self.queryParams.img_height = el.file_height;
          });
          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('objs', param);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/mainBanner?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '메인배너가 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location = "#/main/mainmanagement";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/mainBanner?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '메인배너가 수정되었습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/main/mainmanagement";
                });
            })
          }
        } else {
          window.scrollTo(0,0);
        }
      })
    },
    // 메소드명 : handleFileUpload()
    // ### 단일 파일업로드 ###
    // 한개의 파일 업로드를 진행한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - fileType : 파일 타입
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleFileUpload(fileType){
      var self = this;
      self.queryParams.listThumbnailFile = [];
      var token = sessionStorage.getItem("myToken");
      self.file = self.$refs.file.files[0];
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('reportType', 'mainbanner');
      formData.append('fileSubPath', 'img');

      self.$http.post('/ftpserver/dropAndSingleFileUpload?access_token='+token, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((result) => {
          result.data.file_type_code = fileType;
          self.queryParams.listThumbnailFile.push(result.data);
          self.queryParams.listThumbnailFile.forEach(function (el, idx, arr){
            self.queryParams.img_url = el.file_url;
            self.queryParams.img_width = el.file_width;
            self.queryParams.img_height = el.file_height;
          });
          $(".imgnone").hide();
          self.imgFileCheck = true;
          $("#imgcreat").hide();
          $("#imgdata").show();
          $("#imgdata").attr("src" ,self.queryParams.img_url);
          $("#imgdel").show();
      })
    },
    imgFileDelete(){
      var self = this;
      console.log(self.queryParams);
      console.log(self.queryParams.listThumbnailFile.length);
      self.queryParams.listThumbnailFile = [];
      $("#imgcreat").show();
      $("#imgcreat").css("display", "table-cell");
      $("#imgdata").hide();
      $("#imgdata").attr("src", "");
      $("#imgdel").hide();
      $("#file").val('');
    }
  }
}

$(document).ready(function(){
	var xOffset = 50;
  var yOffset = 10;
  $(document).on("mouseover",".imgview",function(e){ //마우스 오버시
      $("body").append("<p id='preview'><img src='"+ $(this).attr("data") +"' /></p>"); //보여줄 이미지를 선언
      $("#preview")
          .css("position","absolute")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px")
          .fadeIn("fast"); //미리보기 화면 설정 셋팅
  });
  $(document).on("mousemove",".imgview",function(e){ //마우스 이동시
      $("#preview")
          .css("top",(e.pageY - xOffset) + "px")
          .css("left",(e.pageX + yOffset) + "px");
  });
  $(document).on("mouseout",".imgview",function(){ //마우스 아웃시
      $("#preview").remove();
  });
});
</script>
<style lang="css" scoped>
.delete_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #f42f2d; font-size:15px}
.delete_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #f42f2d; font-size:15px}
.clear_button_on {color:#ffffff; border-radius:5px; cursor:pointer; border:1px solid #55a0bb; font-size:15px}
.clear_button_off {color:#ffffff; border-radius:5px; cursor:auto; border:1px solid #55a0bb; font-size:15px}

.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}

.imgdiv {
  margin:0 auto;
  display: inline-table;
  border:1px solid #a3b6c0;
  min-width:1352px;
  min-height:360px;
}

.imgdivnone {
  margin:0 auto;
  display: inline-table;
  border:1px solid #ea0000;
  min-width:1352px;
  min-height:360px;
}

img {
  display: block;
  max-width:1350px;
  max-height:850px;
  width: auto;
  height: auto;
}

.imgfile {
  border:1px solid #c2cfd6; border-radius:4px; width:70%; float:left
}

.imgfilenone {
  border:1px solid #ea0000; border-radius:4px; width:70%; float:left
}

.imgnone {
    padding: 12px 24px;
    background-color: hsl(222, 100%, 95%);
    color: hsl(243, 80%, 62%);
    border-radius: 6px;
    box-shadow: 0 0 0 0 rgba(200, 25, 25, 0.7);
    animation: pulse 1.75s infinite cubic-bezier(0.66, 0, 0, 1);
}

@keyframes pulse {
    to {
      box-shadow: 0 0 0 30px rgba(200, 25, 25, 0);
    }
}
</style>
<style src="daterangepicker/daterangepicker.css"></style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/main/MainManagementForm.vue